import { createFileRoute } from "@tanstack/react-router"
import { CompanyEmployeesPage } from "@/features/companies/company-employees-page"
export const Route = createFileRoute("/_authenticated/companies/$companyId/employees/")({
    component: CompanyEmployeesPage,
})
